import React from "react";

export const Happy:React.VFC =() => {
  return <h3>Happy</h3>
}